import PaymentWallet from '../members/payment-wallet';
import { showAlertMsg } from '../members/member-show-alert-msg';
import { submitPledgeWalletPayment } from './pledge-pay-bill-submit';
import { getPledgePayConfig } from './pledge-pay-config';

function pledgePayChargeAmount($body) {
    const summaryAmount = String($body.find('#mgr_summary_paying_today').text() || '')
        .replace(/[^0-9.-]/g, '');
    const parsedSummary = parseFloat(summaryAmount);
    if (Number.isFinite(parsedSummary)) {
        return parsedSummary;
    }
    return parseFloat($body.find('#total_amount').val()) || 0;
}

function initPledgeExpressPay($body, pledges, cfg = null) {
    const expressPay = $body.find('[data-pledge-express-pay]').get(0);
    if (!expressPay || expressPay.dataset.walletInitialized === 'true') {
        return;
    }
    expressPay.dataset.walletInitialized = 'true';

    const config = cfg || getPledgePayConfig();
    const gatewayIds = new Set(
        (pledges || [])
            .map((pledge) => parseInt(pledge.gateway_id, 10))
            .filter((gatewayId) => Number.isFinite(gatewayId) && gatewayId > 0)
    );
    if (gatewayIds.size !== 1) {
        return;
    }

    const gatewayId = String([...gatewayIds][0]);
    const walletConfig = config.walletConfigsByGateway?.[gatewayId];
    if (!walletConfig) {
        return;
    }

    const amount = () => pledgePayChargeAmount($body);
    if (walletConfig.googlePay) {
        PaymentWallet.initGooglePay(
            walletConfig.googlePay,
            amount,
            'USD',
            (tokenData) => submitPledgeWalletPayment($body, config, tokenData),
            (message) => showAlertMsg(message, 'danger')
        );
    }

    if (walletConfig.applePay) {
        PaymentWallet.initApplePay(
            walletConfig.applePay,
            amount,
            'USD',
            (tokenData, complete) => submitPledgeWalletPayment($body, config, tokenData, complete),
            (message) => showAlertMsg(message, 'danger'),
            null
        );
    }
}

export { initPledgeExpressPay };
